import css from 'styled-jsx/css';

const cookiesPopoverStyles = css`
  .container {
    display: flex;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    justify-content: space-between;
    color: #1e364b;
  }
  .underlined-link {
    border-bottom: 1px solid #1e364b;
  }
  .bold {
    font-weight: 700;
  }
  .first-line {
    padding-bottom: 4px;
  }
`;

export { cookiesPopoverStyles };
